<template>
  <div>
    <v-container
      fluid
    >
      <!-- DESKTOP -->
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-row>
          <!-- COMPANY -->
          <v-col
            class="column"
          >
            <div class="content text-center">
              <img
                v-if="helpers.checkImgURL(qd.imageSiteRemote)"
                :src="qd.imageSiteRemote"
                :alt="qd.insurer"
                class="provider-logo d-inline"
              >

              <h2 v-if="qd.insurer">{{ qd.insurer }}</h2>
            </div>
          </v-col>
          <!-- OPENING HOURS -->
          <v-col
            class="column"
          >
            <ul
              v-if="qd.callOpeningHours && !openingHoursEmpty"
              class="content"
            >
              <li
                v-for="(hour, index) in qd.callOpeningHours"
                :key="index"
              >
                {{ hour }}
              </li>
            </ul>
            <span
              v-else
              class="content"
            >
              Not listed
            </span>
          </v-col>
          <!-- COMPANY INFO -->
          <v-col
            class="column info-col"
          >
            <ul class="content">
              <li
                v-for="(info, index) in qd.companyInfo"
                :key="index"
                class="d-flex"
              >
                <div
                  v-if="info"
                  class="d-flex"
                >
                  <v-icon
                    size="12"
                    class="align-self-baseline mt-1"
                  >
                    mdi-check-outline
                  </v-icon>
                  <span class="ml-2">{{ info }}</span>
                </div>
              </li>
            </ul>
          </v-col>
          <!-- WEBSITE -->
          <v-col
            class="column"
          >
            <div class="content">
              <v-btn
                :href="qd.websiteLink"
                :disabled="!qd.websiteLink"
                rounded
                block
                target="_blank"
                class="pa-0 buyonline-link"
                @click="onClickToBuy"
              >
                <v-icon class="mr-3">
                  mdi-open-in-new
                </v-icon>
                <span>Go to website</span>
              </v-btn>
            </div>
          </v-col>
          <!-- TELEPHONE -->
          <v-col
            class="column"
          >
            <div class="content">
              <v-btn
                v-if="!showConfirmTelephone"
                :disabled="!qd.telephone"
                rounded
                block
                color="primary"
                class="pa-0"
                outlined
                @click="onClickToCall"
              >
                <v-icon
                  class="mr-3"
                >
                  mdi-phone
                </v-icon>
                <span>Call provider</span>
              </v-btn>

              <template v-else>
                <h3 class="fs-12 text-center">Are you sure? They have your details and should be in touch soon.</h3>
                <div class="radio-wrapper">
                  <radio
                    v-model="isTelephoneVisible"
                    small
                    name="confirm-telephone"
                    :items="constants.YES_NO"
                  />
                </div>
              </template>

              <v-card
                v-if="isTelephoneVisible"
                outlined
                class="mt-2"
              >
                <v-card-title class="body-1 font-weight-bold text-center justify-center fs-16">
                  <a
                    :href="`tel:${qd.telephone}`"
                    class="black--text text-decoration-underline"
                  >{{ qd.telephone }}</a>
                </v-card-title>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </template>

      <!-- TABLETS/MOBILES -->
      <template v-else>
        <v-row>
          <!-- Logo -->
          <v-col
            class="d-flex flex-column justify-center align-center
                        table-right-border table-right-border-light pa-2
                        result-columns-align-width"
          >
            <img
              v-if="helpers.checkImgURL(qd.imageSiteRemote)"
              :src="qd.imageSiteRemote"
              :alt="`${qd.imageSiteRemote} logo`"
              class="provider-logo d-inline"
            >
          </v-col>

          <!-- Insurer -->
          <v-col
            class="d-flex flex-column justify-center align-center
                        table-right-border table-right-border-light pa-2
                        result-columns-align-width"
          >
            <h2 v-if="qd.insurer">{{ qd.insurer }}</h2>

            <v-btn
              text
              small
              color="primary"
              @click="isQuoteExpanded = !isQuoteExpanded"
            >
              <span class="text-decoration-underline">{{ isQuoteExpanded ? 'show less' : 'show more' }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-if="isQuoteExpanded"
          class="d-flex flex-column"
        >
          <div class="d-flex">
            <!-- OPENING HOURS -->
            <v-col
              class="column"
            >
              <h3 class="header">
                Opening Hours
              </h3>

              <ul
                v-if="qd.callOpeningHours && !openingHoursEmpty"
                class="content"
              >
                <li
                  v-for="(hour, index) in qd.callOpeningHours"
                  :key="index"
                >
                  {{ hour }}
                </li>
              </ul>
              <span
                v-else
                class="content"
              >
                Not listed
              </span>
            </v-col>
            <!-- WEBSITE -->
            <v-col
              class="column"
            >
              <h3 class="header">
                Website
              </h3>

              <div class="content d-flex align-center justify-center">
                <div>
                  <v-btn
                    :href="qd.websiteLink"
                    :disabled="!qd.websiteLink"
                    rounded
                    block
                    class="buyonline-link"
                    target="_blank"
                    @click="onClickToBuy"
                  >
                    <v-icon class="mr-3">
                      mdi-open-in-new
                    </v-icon>
                    <span>Go to website</span>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </div>
          <!-- COMPANY INFO -->
          <v-col
            class="column"
          >
            <h3 class="header">
              Company Info
            </h3>

            <ul class="content">
              <li
                v-for="(info, index) in qd.companyInfo"
                :key="index"
                class="d-flex"
              >
                <div
                  v-if="info"
                  class="d-flex"
                >
                  <v-icon
                    size="12"
                    class="align-self-baseline mt-1"
                  >
                    mdi-check-outline
                  </v-icon>
                  <span class="ml-2">{{ info }}</span>
                </div>
              </li>
            </ul>
          </v-col>
          <!-- TELEPHONE -->
          <v-col
            class="column"
          >
            <h3 class="header">
              Prefer to call directly?
            </h3>

            <div class="content d-flex justify-center">
              <div>
                <v-btn
                  v-if="!showConfirmTelephone"
                  :disabled="!qd.telephone"
                  rounded
                  block
                  color="primary"
                  outlined
                  @click="onClickToCall"
                >
                  <v-icon
                    class="mr-3"
                  >
                    mdi-phone
                  </v-icon>
                  <span>Call provider</span>
                </v-btn>

                <template v-else>
                  <h3 class="fs-12 text-center">Are you sure? They have your details and should be in touch soon.</h3>
                  <div class="radio-wrapper">
                    <radio
                      v-model="isTelephoneVisible"
                      small
                      name="confirm-telephone"
                      :items="constants.YES_NO"
                    />
                  </div>
                </template>

                <v-card
                  v-if="isTelephoneVisible"
                  outlined
                  class="mt-2"
                >
                  <v-card-title class="body-1 font-weight-bold text-center justify-center fs-16">
                    <a
                      :href="`tel:${qd.telephone}`"
                      class="black--text text-decoration-underline"
                    >{{ qd.telephone }}</a>
                  </v-card-title>
                </v-card>
              </div>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-container>

    <div
      v-if="hasSpecialOffer"
      class="accent-gradient caption pa-2"
    >
      <v-icon
        small
        color="navy-dark"
        class="mr-2"
      >
        mdi-tag
      </v-icon>
      <span v-html="qd.specialOffer" />
    </div>
  </div>
</template>

<script>
import {
  inject,
} from '@vue/composition-api';

export default {
  name: 'quote-details',
  inject: ['constants', 'helpers'],
  props: {
    qd: {
      type: Object,
      required: true,
    },
    hasSpecialOffer: {
      type: Boolean,
      default: false,
    },
    siteId: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      showConfirmTelephone: false,
      isQuoteExpanded: false,
      isTelephoneVisible: null,
    };
  },
  computed: {
    openingHoursEmpty () {
      return Object.values(this.qd.callOpeningHours).every(x => x === null);
    },
    companyParentName () {
      return `${this.qd.companyParentName || this.qd.insurer} (${this.siteId})`;
    },
  },
  watch: {
    isTelephoneVisible (val) {
      if (val === false) {
        this.showConfirmTelephone = false;
        this.isTelephoneVisible = null;
      }
    },
  },
  methods: {
    async onClickToCall () {
      this.showConfirmTelephone = !this.showConfirmTelephone;

      if (this.clicksCallToProviderAmount === 1) {
        await this.internalTrackerResultsPage('callProvider', true);
      }

      if (this.clicksCallToProviderAmount <= this.constants.MAX_AMOUNT_OF_CLICKS) {
        await this.internalTrackerResultsPage(`phoneProviderClickCompany${this.clicksCallToProviderAmount}`, this.companyParentName);
        this.increaseClicksCallToProvider();
      }
    },
    async onClickToBuy () {
      if (this.clicksToBuyOnlineAmount === 1) {
        await this.internalTrackerResultsPage('goToWebsite', true);
      };

      if (this.clicksToBuyOnlineAmount <= this.constants.MAX_AMOUNT_OF_CLICKS) {
        await this.internalTrackerResultsPage(`goToWebsiteClickCompany${this.clicksToBuyOnlineAmount}`, this.companyParentName);
        this.increaseClicksBuyOnline();
      }
    },
  },
  setup () {
    const internalTrackers = inject('internalTrackers');

    return { ...internalTrackers };
  },
};
</script>

<style lang="scss" scoped>
.column {
  display: flex;
  flex-direction: column;
  padding: 0;

  & + .column {
    border-left: 1px solid $clr-outline;
  }

  @media screen and (min-width: 960px) {
    justify-content: center;
  }
}

.header {
  padding: 10px;
  color: $clr-white;
  background: var(--color, $clr-navy-medium);
  text-align: center;
}

.content {
  padding: 20px 10px;

  @media screen and (max-width: 960px) {
    height: 100%;
  }
}

.info-col {
  min-width: 30%;
}

.radio-wrapper::v-deep {
  .radio-holder {
    justify-content: center;
    margin-top: 10px;

    .radio-item {
      padding: 0;
      margin: 0;

      & + .radio-item {
        margin-left: 15px;
      }
    }
  }
}
</style>

<style scoped lang="scss" src='@/assets/scss/results/results-quote.scss' />
